import { Directive, HostListener, inject } from "@angular/core";
import { Router } from "@angular/router";

@Directive({
  selector: "[app-link-interceptor]",
})
export class LinkInterceptorDirective {
  private router = inject(Router);

  @HostListener("click", ["$event"])
  public onClick(event: PointerEvent): void {
    const target = event.target as HTMLElement;
    const anchor = target.closest("a");

    if (!anchor) return;

    const link = anchor.getAttribute("href");
    if (link?.startsWith("/")) {
      event.preventDefault();
      this.router.navigate([link]);
    }
  }
}
